import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function PermissionHeader() {
    const { t } = useTranslation('permission');
    return (<Column fullWidth align='center'>
        <Header>
            <Text size='2xl' fontWeight='bold'>
                {t('header')}
            </Text>
        </Header>
        <Description>
            <DescriptionText align='center' >
                {t('description')}
            </DescriptionText>
        </Description>
    </Column>);
}

const Header = styled.div`
    padding: 32px 0;
`;

const Description = styled.div`
    padding: 0 20px 20px;
    max-height: 80vh;
    overflow-y: auto;
`;

const DescriptionText = styled(Text)`
    word-break: break-word;
    white-space: pre-wrap;
`;

export default PermissionHeader;
